import * as React from "react";
import { observer } from "mobx-react";
import { RouteComponentProps } from "react-router-dom";
import { useEffect } from "react";
import { Spin, message } from "antd";
import * as firebase from "firebase/app";
import "firebase/auth";
import { buildEmail } from "../../stores/ContactViewStore";

export const MagicLink = observer(
  ({
    match,
    history
  }: RouteComponentProps<{ username: string; password: string }>) => {
    useEffect(() => {
      firebase
        .auth()
        .signOut()
        .then(() => {
          localStorage.removeItem("gift.postal.username");
          localStorage.removeItem("gift.postal.password");
          return firebase
            .auth()
            .signInWithEmailAndPassword(
              buildEmail(match.params.username),
              match.params.password
            );
        })
        .then(
          () => {
            localStorage.setItem("gift.postal.username", match.params.username);
            localStorage.setItem("gift.postal.password", match.params.password);
            message.success("ログインに成功しました");
            history.push("/application/order");
          },
          _ => {
            alert("エラーが発生しました");
          }
        );
    }, []);
    return <Spin />;
  }
);
